import Common from '../../Common';

export interface UserSMS {
	id?: number
	sender: null | string
	body: string
	destinations: { destination: string }[]
}

export type UserSmsBrowse = UserSMS & {
	added: string
	confirmed: string
}

export interface UserSmsBody {
	numbers: string[],
	sender: string,
	body: string
}

const SMS = class extends Common {
	browse = (search: any = {}): CustomResponseBrowse<{ sms: UserSmsBrowse[] }> =>
		this.get(`/user/sms`, search)

	read = (smsId: id) =>
		this.get(`/user/sms/${smsId}`)

	create = (data: UserSmsBody) =>
		this.post(`/user/sms`, data)
}

export default SMS;
